const EVENT_LIST_PATH_PATTERN = /^\/(?:(?:en|el|de|ar)\/)?events$/;
const EVENT_PATH_PATTERN = /^\/(?:(?:en|el|de|ar)\/)?event\/([A-Za-z0-9][A-Za-z0-9_-]{0,199})$/;

export const normalizeEventRedirectPath = value => {
  if (typeof value !== 'string') return null;

  const path = value.trim();
  if (EVENT_LIST_PATH_PATTERN.test(path)) return path;

  return EVENT_PATH_PATTERN.test(path) ? path : null;
};

export const sanitizeInternalReturnPath = value => {
  if (typeof value !== 'string') return null;

  const path = value.trim();
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\')) return null;
  const hasControlCharacter = Array.from(path).some(character => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
  });
  if (hasControlCharacter) return null;

  try {
    const baseUrl = 'https://vivianlab.invalid';
    const parsed = new URL(path, baseUrl);
    const decodedPathname = decodeURIComponent(parsed.pathname);
    if (
      parsed.origin !== baseUrl ||
      decodedPathname.startsWith('//') ||
      decodedPathname.includes('\\')
    ) {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (_error) {
    return null;
  }
};

export const buildExpiredMobileLoginPath = redirectPath => {
  const safeRedirectPath = normalizeEventRedirectPath(redirectPath) || '/events';
  const params = new URLSearchParams({
    redirect: safeRedirectPath,
    authMessage: 'mobile_link_expired',
  });
  return `/login?${params.toString()}`;
};

export const getMobileAuthTokenFromHash = hash => {
  if (typeof hash !== 'string' || !hash.startsWith('#')) return null;
  return new URLSearchParams(hash.replace(/^#/, '')).get('token');
};
